<div class="agro-dealer-list-container">
  <div class="header">
    <span class="title">Manage Agro Dealers</span>
  </div>
  <div class="top-section">
    <div class="search-bar-container">
      <input
        type="text"
        placeholder="Search name, location or number"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchTermChange()"
        class="search-input"
        (keyup.enter)="applySearch()"
      />
      <mat-icon class="search-icon" (click)="applySearch()">search</mat-icon>
    </div>

    <!-- <button mat-stroked-button color="accent" class="refresh-location-button" (click)="refreshLocation()">
      <mat-icon>my_location</mat-icon> Refresh My Location
    </button> -->
    <div class="my-dealers-toggle-section">
      <span class="toggle-label">My Agro Dealers</span>
      <mat-slide-toggle [(ngModel)]="showMyDealers" color="primary" (change)="loadDealers()"></mat-slide-toggle>
    </div>
    
    <div class="total-dealers-count">
      Total Agro Dealers: {{ totalDealers }}
    </div>
  </div>

  <div class="dealer-list">
    <div
      class="dealer-card"
      *ngFor="let dealer of dealers"
      (click)="viewDealerDetails(dealer)"
    >
      <div class="dealer-image-wrapper">
        <img 
        src="{{dealer.retailerShopImage ? dealer.retailerShopImage : '../../../assets/Agri_Shop.svg'}}" 
        alt="Dealer Product Image" 
        class="dealer-image" />
      </div>
      <div class="dealer-info">
        <h3 class="dealer-name">{{ dealer.shopName }}</h3>
        <p class="dealer-location">
          <mat-icon class="info-icon">location_on</mat-icon> {{ dealer.state }}, {{dealer.district}}
        </p>
        <p class="dealer-phone">
          <mat-icon class="info-icon">phone</mat-icon> {{ dealer.mobileNumberPrimary }}
        </p>
      </div>
      <mat-icon class="arrow-icon">chevron_right</mat-icon>
    </div>
    <div *ngIf="isLocationLoading" class="loading-spinner">
      <mat-spinner [diameter]="30"></mat-spinner>
      <p>Fetching Location...</p>
    </div>
    <div *ngIf="!isLoading && !isLocationLoading && dealers.length === 0" class="no-dealers-message">
      <p>No agro dealers found matching your criteria.</p>
    </div>
  </div>

  <div class="bottom-button-wrapper">
    <button mat-raised-button color="primary" class="add-dealer-button" (click)="onAddDealer()">
      Add Agro Dealer
    </button>
  </div>

</div>